import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=76eccc12&scoped=true&"
import script from "./AccountBalance.vue?vue&type=script&lang=ts&"
export * from "./AccountBalance.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=76eccc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eccc12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
